import React from 'react';
import FooterLinkItem from '@theme-original/Footer/LinkItem';
import useDocusaurusContext from '@docusaurus/useDocusaurusContext';
import {useLocation} from '@docusaurus/router';
import useIsBrowser from '@docusaurus/useIsBrowser';
import {getPricingRegisterHref} from '@site/src/components/FreeTools/shared/freeToolLinks';

export default function AttributedFooterLinkItem(props) {
    const {siteConfig} = useDocusaurusContext();
    const frontendUrl = siteConfig.customFields.frontendUrl;
    const location = useLocation();
    const isBrowser = useIsBrowser();
    const defaultRegisterHref = `${frontendUrl}/register`;
    const registerHref = isBrowser ? getPricingRegisterHref(frontendUrl, location) : defaultRegisterHref;
    const {item} = props;

    return <FooterLinkItem {...props} item={{
        ...item,
        to: item.to === defaultRegisterHref ? registerHref : item.to,
        href: item.href === defaultRegisterHref ? registerHref : item.href
    }}/>;
}
